<template>
  <!-- UPD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 start↓ -->
  <!-- <div class="background"> -->
  <div class="background" v-loading="showFlag">
    <!-- UPD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 end↑ -->
    <div class="welcomeTextDiv">
      <span class="welcomeText">{{ $t("resource.txt.welcomeCompany") }}</span>
      <span class="welcomeTextLEAP">{{ $t("resource.txt.welcomeLEAP") }}</span>
      <span class="welcomeTextX">{{ $t("resource.txt.welcomeX") }}</span>
      <br />
      <span class="welcomeText" style="font-size: 20pt">{{
        $t("resource.txt.welcomeSystem")
      }}</span>
    </div>
    <div class="login-container">
      <t-form
        v-if="isTrusted"
        ref="loginForm"
        domain="loginForm"
        :model="loginForm"
        class="login-form"
        autocomplete="on"
        label-position="left"
      >
        <div class="inner_card" v-if="isLogin">
          <t-form-item prop="username">
            <t-input
              ref="username"
              v-model="loginForm.username"
              placeholder="ユーザ"
              name="username"
              tabindex="1"
              autocomplete="on"
            >
              <template slot="prepend"
                ><em class="el-icon-user-solid"
              /></template>
            </t-input>
          </t-form-item>

          <t-form-item prop="password">
            <t-input
              key="password"
              ref="password"
              v-model="loginForm.password"
              type="password"
              placeholder="パスワード"
              name="password"
              tabindex="2"
              class="inputPassWord"
              @keyup.enter.native="handleLogin"
            >
              <template slot="prepend"><em class="el-icon-key" /></template>
            </t-input>
          </t-form-item>
          <t-form-item>
            <t-button
              type="primary"
              style="height: 40px; font-size: 100%; width: 100%"
              @click.native.prevent="handleLogin"
              >{{ $t("resource.button.login") }}
            </t-button>
          </t-form-item>
        </div>
        <div v-if="isChangePwd" class="card__inner">
          <t-row>
            <t-col :span="24">
              <span class="card-title__no"
                >{{ $t("resource.txt.changePassword") }}
              </span>
            </t-col>
          </t-row>
          <div class="label-text-50">
            <div class="label-text float-left mt-2">
              {{ $t("resource.txt.inputPwd") }}
            </div>
            <t-tooltip
              v-model="capsTooltip"
              content="Caps lock is On"
              placement="right"
              manual
            >
              <t-form-item prop="oldPassword">
                <t-input
                  key="oldPassword"
                  ref="oldPassword"
                  v-model="loginForm.oldPassword"
                  name="oldPassword"
                  type="password"
                  tabindex="1"
                  autocomplete="on"
                  @blur="capsTooltip = false"
                />
              </t-form-item>
            </t-tooltip>

            <div class="label-text float-left mt-2">
              {{ $t("resource.txt.inputNewPwd") }}
            </div>
            <t-tooltip
              v-model="capsTooltip"
              content="Caps lock is On"
              placement="right"
              manual
            >
              <t-form-item prop="newPassword">
                <t-input
                  key="newPassword"
                  ref="newPassword"
                  v-model="loginForm.newPassword"
                  type="password"
                  name="newPassword"
                  tabindex="2"
                  autocomplete="on"
                  @blur="capsTooltip = false"
                />
              </t-form-item>
            </t-tooltip>

            <div class="label-text float-left mt-2">
              {{ $t("resource.txt.confirmPwd") }}
            </div>
            <t-tooltip
              v-model="capsTooltip"
              content="Caps lock is On"
              placement="right"
              manual
            >
              <t-form-item prop="checkPassword">
                <t-input
                  key="checkPassword"
                  ref="checkPassword"
                  v-model="loginForm.checkPassword"
                  type="password"
                  name="checkPassword"
                  tabindex="3"
                  autocomplete="on"
                  @blur="capsTooltip = false"
                />
              </t-form-item>
            </t-tooltip>
            <t-form-item>
              <t-button
                class="button-password mt-2"
                type="primary"
                @click.native.prevent="changePwd()"
                ><em class="el-icon-edit pr-1" />{{
                  $t("resource.login.change")
                }}</t-button
              >
            </t-form-item>
          </div>
        </div>

        <!-- ADD 2025/11/13 ZLL 課題_ユーザログインのMFA認証処理の追加 start↓ -->
      </t-form>
      <t-form
        v-if="!isTrusted"
        ref="mfaCodeForm"
        domain="mfaCodeForm"
        :model="mfaCodeForm"
        class="login-form"
        label-position="left"
        @submit.native.prevent
      >
        <!-- 認証コード -->
        <div class="inner_card">
          <t-form-item class="marginBottom"
            ><span>MFA認証コードの有効期限は5分です。</span></t-form-item
          >
          <t-form-item prop="verifyCode" class="marginBottom">
            <t-input
              ref="verifyCode"
              v-model="mfaCodeForm.verifyCode"
              placeholder="認証コード"
              name="verifyCode"
              tabindex="1"
              key="verifyCode"
              @keyup.enter.native="verifyCodeConfirm"
            >
              <template slot="prepend"><em class="el-icon-key" /></template>
            </t-input>
          </t-form-item>

          <t-form-item prop="setTrustDevice" class="marginBottom">
            <label>
              <input v-model="setTrustDevice" type="checkbox" />
              この端末を信頼する
            </label>
          </t-form-item>
          <t-form-item>
            <t-button
              type="primary"
              style="height: 40px; font-size: 100%; width: 45%"
              ref="returnBtn"
              @click="returnLogin"
              >{{ $t("resource.button.return_login") }}
            </t-button>

            <t-button
              type="primary"
              style="height: 40px; font-size: 100%; width: 45%"
              @click.native.prevent="verifyCodeConfirm"
              >{{ $t("resource.button.return_Confirm") }}
            </t-button>
          </t-form-item>
        </div>
        <!-- ADD 2025/11/13 ZLL 課題_ユーザログインのMFA認証処理の追加 end↑ -->
      </t-form>
    </div>
  </div>
</template>

<script>
import { loginRequest } from "@/api/request";
import { clearAuth, clearUserInfo, getUserInfo } from "@/auth";
import { t } from "@/locales";
import service from "@/services/userManage";
import { RESULT_TD, STR_DEPARTMENT_SEVEN } from "@/utils/const";
import { Modal } from "@tellus/component";
import { resetRouter } from "@tellus/router";
import { Message } from "@tellus/ui";
export default {
  name: "Login",
  data() {
    return {
      loginForm: {
        username: "",
        password: "",
        oldPassword: "",
        newPassword: "",
        checkPassword: "",
      },
      capsTooltip: false,
      isLogin: true,
      isChangePwd: false,

      // ADD 2025/11/13 ZLL 課題_ユーザログインのMFA認証処理の追加 start↓
      isTrusted: true,

      mfaCodeForm: {
        // MFAコード
        verifyCode: "",
      },

      setTrustDevice: false,

      deviceInfo: {
        deviceId: "",
        deviceName: "",
      },
      department: "",
      showFlag: false,
      // ADD 2025/11/13 ZLL 課題_ユーザログインのMFA認証処理の追加 end↑
    };
  },

  // ADD 2025/11/13 ZLL 課題_ユーザログインのMFA認証処理の追加 start↓
  mounted() {
    //　デバイス情報の取得
    this.initDeviceInfo();
  },
  // ADD 2025/11/13 ZLL 課題_ユーザログインのMFA認証処理の追加 end↑

  methods: {
    // ADD 2025/11/13 ZLL 課題_ユーザログインのMFA認証処理の追加 start↓
    //　デバイス情報の取得
    initDeviceInfo() {
      // デバイスIDの取得
      this.deviceInfo.deviceId = this.generateSimpleFingerprint();
      // デバイス名の取得
      this.deviceInfo.deviceName = this.getDeviceName();
    },

    // デバイスIDの取得
    generateSimpleFingerprint() {
      const components = [
        this.detectBrowser(navigator.userAgent),
        navigator.language,
        navigator.hardwareConcurrency || "",
        screen.colorDepth + "bit",
        screen.width + "x" + screen.height,
        Intl.DateTimeFormat().resolvedOptions().timeZone,
        new Date().getTimezoneOffset(),
        navigator.maxTouchPoints || "",
        this.getCanvasFingerprint(), // キャンバスフィンガープリントを追加
        localStorage.getItem("deviceUniqueId") || this.generateUniqueId(),
      ];

      const fingerprint = components.join("|");
      return btoa(fingerprint).replace(/[+/=]/g, "").substring(0, 32);
    },

    // キャンバスフィンガープリントを追加
    getCanvasFingerprint() {
      try {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        ctx.textBaseline = "top";
        ctx.font = "14px Arial";
        ctx.fillText("BrowserFingerprint", 2, 2);
        return canvas.toDataURL().substring(22, 40); // 一部のデータを抽出する
      } catch (e) {
        return "canvas_not_supported";
      }
    },

    // ユニークIDの生成
    generateUniqueId() {
      const uniqueId =
        "device_" + Date.now() + "_" + Math.random().toString(36).substr(2, 9);
      localStorage.setItem("deviceUniqueId", uniqueId);
      return uniqueId;
    },

    // デバイス名の取得
    getDeviceName() {
      const ua = navigator.userAgent;
      // バージョン番号を削除
      const browser = this.detectBrowser(ua).split("_")[0];
      const os = this.detectOS(ua);
      const device = this.detectDevice(ua);
      return `${device} (${browser} - ${os})`;
    },

    // ブラウザの取得
    detectBrowser(ua) {
      const browsers = [
        { pattern: /Edg\/([\d.]+)/, name: "Edge" },
        { pattern: /Firefox\/([\d.]+)/, name: "Firefox" },
        { pattern: /Chrome\/([\d.]+)/, name: "Chrome" },
        { pattern: /Safari\/([\d.]+)/, name: "Safari" },
        { pattern: /OPR\/([\d.]+)/, name: "Opera" },
        { pattern: /MSIE ([\d.]+)/, name: "IE" },
        { pattern: /Trident\/.*rv:([\d.]+)/, name: "IE" },
      ];

      for (const browser of browsers) {
        const match = ua.match(browser.pattern);
        if (match) {
          return `${browser.name}_${match[1]}`;
        }
      }
      return "UnknownBrowser";
    },

    // オペレーティングシステムを取得する
    detectOS(ua) {
      const osPatterns = [
        { test: () => ua.includes("Windows"), name: "Windows" },
        // Mac OS
        { test: () => ua.includes("Macintosh"), name: "macOS" },

        // Linux
        { test: () => ua.includes("Ubuntu"), name: "Ubuntu" },
        { test: () => ua.includes("Fedora"), name: "Fedora" },
        { test: () => ua.includes("Linux"), name: "Linux" },

        // モバイルデバイス
        { test: () => ua.includes("Android"), name: "Android" },
        { test: () => ua.includes("iPhone"), name: "iOS" },
        { test: () => ua.includes("iPad"), name: "iOS" },
      ];

      for (const osPattern of osPatterns) {
        if (osPattern.test()) {
          return osPattern.name;
        }
      }

      return "Unknown OS";
    },

    // デバイス区分の取得
    detectDevice(ua) {
      const isMobile = /Mobile|Android|iPhone|iPod/.test(ua);
      const isTablet =
        /Tablet|iPad/.test(ua) || (isMobile && screen.width >= 768);

      if (isTablet) return "Tablet";
      if (isMobile) return "Mobile";
      return "PC";
    },
    // ADD 2025/11/13 ZLL 課題_ユーザログインのMFA認証処理の追加 end↑

    //登録
    handleLogin() {
      // ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 start↓
      if (this.showFlag) {
        return;
      }
      this.showFlag = true;
      // ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 end↑

      let userInfo = getUserInfo();

      if (!!userInfo) {
        clearUserInfo();
        clearAuth();
        resetRouter();
      }

      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          loginRequest({
            userId: this.loginForm.username,
            password: this.loginForm.password,
          })
            .then((res) => {
              // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
              // ルート権限検証 MFA 完了チェックの追加
              sessionStorage.removeItem('mfaCompleted')
              // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑

              // UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
              // 品質保証部の権限を追加する

              // // ログイン後はデフォルトでmain画面に入る
              // this.$router.push({ path: "/" });
              // //ローカルストレージにユーザーIDを追加する
              // localStorage.setItem("userId", this.loginForm.username);

              service
                // UPD 2025/11/13 ZLL 課題_ユーザログインのMFA認証処理の追加 start↓
                // .GetUserInfoDataById(this.loginForm.username)
                .GetLoginUserInfoById({
                  userId: this.loginForm.username,
                  trustedDevicesInfo: this.deviceInfo,
                })
                // UPD 2025/11/13 ZLL 課題_ユーザログインのMFA認証処理の追加 end↑
                .then((res) => {
                  // UPD 2025/11/13 ZLL 課題_ユーザログインのMFA認証処理の追加 start↓
                  // //品質保証部
                  // var isDLUser =
                  //   res.userInfo.department == STR_DEPARTMENT_SEVEN;
                  // //ローカルストレージに品質保証部フラグを追加する
                  // sessionStorage.setItem("isDLUser", isDLUser);

                  // // ログイン後はデフォルトでmain画面に入る
                  // this.$router.push({ path: "/" });
                  // //ローカルストレージにユーザーIDを追加する
                  // localStorage.setItem("userId", this.loginForm.username);

                  // 認証済みデバイスの場合
                  this.department = res.userInfo.department;
                  if (res.codeSendResult === RESULT_TD) {
                    // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
                    // ルート権限検証 MFA 完了チェックの追加
                    sessionStorage.setItem('mfaCompleted', 'true')
                    // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑
                    this.loginToMain();
                  } else {
                    this.isTrusted = false;
                  }
                  this.showFlag = false;

                  // UPD 2025/11/13 ZLL 課題_ユーザログインのMFA認証処理の追加 end↑
                })
                .catch((err) => {
                  // ADD 2025/11/13 ZLL 課題_ユーザログインのMFA認証処理の追加 start↓
                  this.showFlag = false;
                  if (err.data != null) {
                    // Modal.showWarning("", err.data.Messages[0].Message, {
                    //   confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"), // COMMON_MESSAGE
                    // });

                    Modal.showWarning(
                      "",
                      t(
                        "message.COMMON_MESSAGE." + err.data.Messages[0].Message
                      ),
                      {
                        confirmButtonText: t(
                          "resource.COMMON_CONSTANT.CONFIRM"
                        ),
                      }
                    );
                  } else {
                    // ADD 2025/11/13 ZLL 課題_ユーザログインのMFA認証処理の追加 end↑
                    Message({
                      type: "error",
                      message: "システムエラー",
                    });
                  }
                });
              // UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
            })
            .catch((err) => {
              // ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 start↓
              this.showFlag = false;
              // ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 end↑
              if (err.data != null) {
                Modal.showWarning("", err.data.Messages[0].Message, {
                  confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
                });
              } else {
                Modal.showWarning("", t("message.login.loginErr"), {
                  confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
                });
              }
            });
        }
        // ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 start↓
        else {
          this.showFlag = false;
        }
        // ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 end↑
      });
    },

    // ADD 2025/11/13 ZLL 課題_ユーザログインのMFA認証処理の追加 start↓
    // ログイン後はデフォルトでmain画面に入る
    loginToMain() {
      //品質保証部
      var isDLUser = this.department == STR_DEPARTMENT_SEVEN;
      //ローカルストレージに品質保証部フラグを追加する
      sessionStorage.setItem("isDLUser", isDLUser);

      // ログイン後はデフォルトでmain画面に入る
      this.$router.push({ path: "/" });
      //ローカルストレージにユーザーIDを追加する
      localStorage.setItem("userId", this.loginForm.username);
    },

    // ログインを戻る
    returnLogin() {
      // ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 start↓
      // フォーカス削除
      this.$refs.returnBtn.$el.blur();
      Modal.showWarning("", t("message.login.return"), {
        $type: "prompt",
        confirmButtonText: t("resource.button.sure"),
        cancelButtonText: t("resource.button.cancel"),
        showCancelButton: true,
      })
        .then(() => {
          // ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 end↑

          // 用户点击确认
          this.$nextTick(() => {
            this.$refs.mfaCodeForm.clearValidate(["verifyCode"]);
          });
          this.mfaCodeForm.verifyCode = "";
          this.isTrusted = true;
          // ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 start↓
        })
        .catch((error) => {
          // 用户点击取消或关闭对话框
          return;
        });
      // ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 end↑
    },

    verifyCodeConfirm() {
      // ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 start↓
      if (this.showFlag) {
        return;
      }
      this.showFlag = true;
      // スペースを削除する
      this.mfaCodeForm.verifyCode = this.mfaCodeForm.verifyCode.trim();
      // ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 end↑
      this.$refs.mfaCodeForm.validate((valid) => {
        if (valid) {
          service
            .ChkCodeSetTrustDev({
              userId: this.loginForm.username,
              trustedDevicesInfo: this.deviceInfo,
              setTrustedDevice: this.setTrustDevice,
              verifyCode: this.mfaCodeForm.verifyCode,
            })
            .then((res) => {
              // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
              // ルート権限検証 MFA 完了チェックの追加
              sessionStorage.setItem('mfaCompleted', 'true')
              // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑
              this.loginToMain();
              // ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 start↓
              this.showFlag = false;
              // ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 end↑
            })
            .catch((err) => {
              // ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 start↓
              this.showFlag = false;
              // ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 end↑
              if (err.data != null) {
                Modal.showWarning(
                  "",
                  t("message.COMMON_MESSAGE." + err.data.Messages[0].Message),
                  {
                    confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
                  }
                );
              } else {
                Message({
                  type: "error",
                  message: "システムエラー",
                });
              }
            });
        }
        // ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 start↓
        else {
          this.showFlag = false;
        }
        // ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 end↑
      });
    },
    // ADD 2025/11/13 ZLL 課題_ユーザログインのMFA認証処理の追加 end↑

    changePwd() {
      this.$refs["loginForm"].validate((valid) => {
        if (valid) {
          if (this.loginForm.newPassword === this.loginForm.checkPassword) {
            service
              .ChangePwd({
                userId: this.loginForm.username,
                oldPassword: this.loginForm.oldPassword,
                newPassword: this.loginForm.newPassword,
              })
              .then(() => {
                Message({
                  type: "success",
                  message: t("message.loginForm.changePwd2"),
                });
                this.isLogin = true;
                this.isChangePwd = false;
              })
              .catch((err) => {
                Message({
                  type: "error",
                  message: err.data.Messages[0].Message,
                });
              });
          } else {
            Message({
              type: "error",
              message: t("message.loginForm.changePwd1"),
            });
          }
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.background {
  width: 100%;
  height: 100%;
  position: fixed;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-color: #c1cbd7;
  //background-image: url("../../assets/images//bg2.png");
  opacity: 0.8;
}

.welcomeTextDiv {
  height: 420px;
  width: 320px;
  text-align: left;
  position: absolute;
  left: 50%;
  top: 55%;
  transform: translate(-50%, -50%);
  overflow: hidden;
  background-size: 100% 100%;
  opacity: 1;
}

.welcomeText {
  font-weight: bold;
  font-size: 30pt;
  color: black;
}

.welcomeTextLEAP {
  font-weight: bold;
  font-size: 30pt;
  font-style: italic;
  font-family: "ＭＳ Ｐ明朝" !important;
  color: rgb(0, 176, 240);
}
.welcomeTextX {
  font-weight: bold;
  font-size: 30pt;
  font-style: italic;
  font-family: "ＭＳ Ｐ明朝" !important;
  color: rgb(255, 0, 0);
}

.login-container {
  height: 300px;
  width: 470px;
  position: absolute;
  left: 50%;
  top: 55%;
  transform: translate(-50%, -50%);
  overflow: hidden;
  background-size: 100% 100%;
  opacity: 1;
  margin-top: 10px;
}

.login-form {
  position: relative;
  width: 375px;
  max-width: 100%;
  padding: 5% 3% 0;
  margin-left: 8%;
  overflow: hidden;
}

.inner_card {
  height: 85%;
  width: 85%;
  background-color: #f2f2f2;
  margin-top: 10px;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  padding: 25px 25px 10px 25px;
  box-shadow: 0 10px 16px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.2) !important;
}

.dxw,
.system {
  position: relative;
  text-align: center;
  margin-right: 5%;
  font-size: 50px;
  color: white;
  font-family: "ＭＳ Ｐゴシック";
  font-weight: bold;
}

::v-deep .el-input__inner {
  height: 40px !important;

  .el-input-group__prepend {
    height: 40px;
  }
}

.inputPassWord {
  margin-top: 5%;
}

.button {
  width: 100%;
  border-style: none;
  color: white;
  height: 40px;
  font-size: 100%;
  background-color: #409eff;
}
</style>
